"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDateField = void 0;
const local_date_field_1 = require("../../../components/local-date-field/local-date-field");
const form_field_1 = require("./form-field");
/**
 * @deprecated
 *
 * Use FormLocalDateField instead.
 */
exports.FormDateField = (0, form_field_1.formFieldFactory)(local_date_field_1.LocalDateField);
//# sourceMappingURL=form-date-field.js.map